import { SelectItem } from 'primeng/api';

export enum DashboardPreference {
  TranslationAndFiling = 'TRANSLATION_AND_FILING',
  Annuities = 'ANNUITIES',
  Forecaster = 'FORECASTER',
  Reports = 'REPORTS',
  Recordals = 'RECORDALS'
}

export const DASHBOARD_PREFERENCE: SelectItem[] = [
  { label: 'Filing and Translation', value: DashboardPreference.TranslationAndFiling },
  { label: 'Renewal Services', value: DashboardPreference.Annuities },
  { label: 'Forecaster', value: DashboardPreference.Forecaster },
  { label: 'Reports', value: DashboardPreference.Reports },
  { label: 'Recordals', value: DashboardPreference.Recordals },
];
